import type { ReactElement, SVGProps } from "react";

export function SkillsPageLightbulbIcon(
  props: SVGProps<SVGSVGElement>
): ReactElement {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" {...props}>
      <path
        d="M8 1C5.24 1 3 3.24 3 6C3 7.8 3.94 9.38 5.36 10.19C5.74 10.41 6 10.83 6 11.28V12H10V11.28C10 10.83 10.26 10.41 10.64 10.19C12.06 9.38 13 7.8 13 6C13 3.24 10.76 1 8 1Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6 14H10M6 12H10"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
